import { FC } from "react"

import { PointRule } from "types/tournament.types"

import { ACTION_LABELS, CONDITION_LABELS, MODIFIER_LABELS } from "./constants"

interface PresetRulesReadonlyProps {
  rules: PointRule[]
}

export const PresetRulesReadonly: FC<PresetRulesReadonlyProps> = ({ rules }) => {
  if (rules.length === 0) {
    return <p className="text-sm text-gray-500 dark:text-gray-400">No rules defined</p>
  }

  return (
    <div className="space-y-3">
      {rules.map((rule, idx) => (
        <div
          key={rule.id || idx}
          className={`flex items-start gap-3 p-3 rounded-lg border text-sm ${
            rule.enabled !== false
              ? "border-[rgba(0,0,0,0.05)] dark:border-[rgba(255,255,255,0.1)] bg-gray-50 dark:bg-[rgba(255,255,255,0.02)]"
              : "border-gray-200 dark:border-gray-700 bg-gray-100 dark:bg-gray-800/50 opacity-60"
          }`}
        >
          <span className="font-mono text-xs text-gray-400 dark:text-gray-500 mt-0.5">{idx + 1}</span>
          <div className="flex-1 min-w-0">
            <div className="flex items-center gap-2 flex-wrap">
              <span className="font-medium text-gray-900 dark:text-white">{rule.name}</span>
              {rule.enabled === false && (
                <span className="text-xs px-1.5 py-0.5 rounded bg-gray-200 dark:bg-gray-700 text-gray-500 dark:text-gray-400">
                  disabled
                </span>
              )}
            </div>
            <div className="text-xs text-gray-500 dark:text-gray-400 mt-1 flex flex-wrap gap-x-4">
              <span>
                <strong>IF:</strong> {CONDITION_LABELS[rule.if?.type] || rule.if?.type}
                {rule.if?.value !== null && rule.if?.value !== undefined && ` (${rule.if.value})`}
                {rule.if?.count !== null && rule.if?.count !== undefined && ` (${rule.if.count})`}
                {rule.if?.min !== null &&
                  rule.if?.min !== undefined &&
                  rule.if?.max !== null &&
                  rule.if?.max !== undefined &&
                  ` (${rule.if.min}-${rule.if.max})`}
              </span>
              <span>
                <strong>THEN:</strong> {ACTION_LABELS[rule.then?.type] || rule.then?.type}
                {rule.then?.amount !== null && rule.then?.amount !== undefined && ` (${rule.then.amount})`}
                {rule.then?.percentage !== null && rule.then?.percentage !== undefined && ` (${rule.then.percentage}%)`}
                {rule.then?.multiplier !== null && rule.then?.multiplier !== undefined && ` (${rule.then.multiplier}x)`}
              </span>
              {rule.modifier && (
                <span>
                  <strong>LIMIT:</strong> {MODIFIER_LABELS[rule.modifier.type] || rule.modifier.type}
                  {rule.modifier.count !== null && rule.modifier.count !== undefined && ` (${rule.modifier.count})`}
                </span>
              )}
            </div>
          </div>
        </div>
      ))}
    </div>
  )
}
